import React, { useState, useEffect } from "react";
import instance from "../../api/api";
import InputCreate from "../../features/InputCreate";
// import { Help } from "../../utils";
import Swal from "sweetalert2";
// import { Tabs } from 'antd';
import withReactContent from "sweetalert2-react-content";
// import { TabView, TabPanel } from "primereact/tabview";
import Button from "../../features/Button";
import { Header } from "../../shared/compoments";
// import { MultiSelect } from 'primereact/multiselect';
// import { Dropdown } from "primereact/dropdown";
// import useDebounce from "../../hooks/useDebounce";
// import { TabView, TabPanel } from 'primereact/tabview';
function VilleCreate() {
  const styleBtn = {
    padding: ".5em",
    borderRadius: "5px",
    fontWeight: "bold",
    cursor: "pointer",
    color: "black",
    backgroundColor: "rgb(255 177 47 / 99%)",
    marginTop: "1em",
    border: "none",
  };
  const MySwal = withReactContent(Swal);
  // const [isServices, setIsServices] = useState("services");
  const [data, setData] = useState({
    name: "",
  });
  const [dataCommune, setDataCommune] = useState({
    city_id: "",
    name: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  // const [selectedServices, setSelectedServices] = useState("");
  // const [selectedProduits, setSelectedProduits] = useState(null);
  const [allVille, setAllVille] = useState([]);
  const [seeModalVille, setSeeModalVille] = useState(false);
  // const [prixActuelService, setPrixActuelService] = useState("");
  // const [prixActuelPromotions, setPrixActuelPromotions] = useState("");
  // const debouncedValue = useDebounce(data.pourcentage, 500);
  const createMunicipalite = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const data = {
      city_id: dataCommune.city_id,
      names: [dataCommune.name],
    };
    try {
      const responseMunicipalite = await instance.post("municipalite", data);
      if (responseMunicipalite.data.status) {
        MySwal.fire({
          title: "Commune enrégistrée",
          icon: "info",
          showConfirmButton: true,
        });
        setIsLoading(false);
      }
      console.log(responseMunicipalite.data.data);
    } catch (error) {
      console.log(error);
      let msgError = [];
      for (const property in error.response.data.message) {
        msgError = [...msgError, error.response.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoading(false);
    }
  };
  const createCities = async (e) => {
    e.preventDefault();
    try {
      const response = await instance.post("cities", data);
      console.log(response.data.data);
      MySwal.fire({
        title: "Ville enrégistrée",
        icon: "info",
        showConfirmButton: true,
      });
      getListVilles();
      setSeeModalVille(false);
    } catch (error) {
      console.log(error);
      let msgError = [];
      for (const property in error.response.data.message) {
        msgError = [...msgError, error.response.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
    }
  };
  const getListVilles = async () => {
    try {
      const response = await instance.get("cities");
      setAllVille(response?.data.data);
      console.log("response.data.data", response?.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  // const handlePrice = (value) => {
  //   console.log(value);
  //   setPrixActuelService(Number(value.tarif || value.prix));
  //   console.log("prixActuelService", prixActuelService);
  // };

  // useEffect(() => {
  //   function handlePricePromotion(value) {
  //     console.log("handlePricePromotion", value);
  //     const valueAfterPercent = (value * prixActuelService) / 100;
  //     const priceForPromotions = prixActuelService - valueAfterPercent;
  //     setPrixActuelPromotions(priceForPromotions);
  //     console.log("valueAfterPercent", valueAfterPercent);
  //     console.log("priceForPromotions", priceForPromotions);
  //   }
  //   if (debouncedValue) {
  //     console.log("Debounced Value:", debouncedValue);
  //     handlePricePromotion(debouncedValue);
  //   }
  // }, [debouncedValue, prixActuelService]);
  useEffect(() => {
    getListVilles();
  }, []);

  return (
    <div>
      <Header libelle={"Enregistrer une ville"} />
      <form onSubmit={createCities} className="px-3 my-3">
        <div className="row g-3">
          {/* Champ Ville */}
          <div className="col-lg-6">
            <InputCreate
              label="Ville"
              typeInput="text"
              nameInput="ville"
              active={true}
              placeholder="Ex: Abidjan"
              getValue={(e) => {
                setData({ ...data, name: e.target.value });
              }}
              dataValue={data.name}
            />
          </div>

          {/* Bouton Enregistrer */}
          <div className="col-lg-12 d-flex align-items-end">
            <Button
              titre="Enregistrer"
              styleBtn={styleBtn}
              isLoading={isLoading}
            />
          </div>
        </div>
      </form>
      {/* <form onSubmit={createCities} className="px-3 my-3">
        <InputCreate
          label="Ville"
          typeInput="text"
          nameInput="ville"
          active={true}
          getValue={(e) => {
            setData({ ...data, name: e.target.value });
          }}
          dataValue={data.name}
        />
        <div>
          <Button
            titre="Enregistrer"
            styleBtn={styleBtn}
            isLoading={isLoading}
          />
        </div>
      </form> */}
    </div>
  );
}

export default VilleCreate;
